import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const UsersPage = lazy(() => import('./UsersPage'));

const UsersConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.UserManagement,
  routes: [
    {
      path: 'users',
      element: <UsersPage />,
    },
  ],
};

export default UsersConfig;
